import h from './htm';
import domWrap from './domWrap';
import getMonths from './getMonths';

function monthPicker(input) {
	let value = input.value,
		separator = '-',
		[year, month] = value.split(separator),
		[minYear, minMonth] = input.getAttribute('min').split(separator),
		[maxYear, maxMonth] = input.getAttribute('max').split(separator),
		container = h('month-picker',
			h('section',
				h('select',
					(new Array(maxYear - minYear + 1)).fill(0).map((item, index) => {
						let thisYear = parseInt(minYear) + index;
						return h(`option ${thisYear === parseInt(year) ? 'selected="selected"' : ''}`, thisYear);
					}).reverse().join('')
				)('button class="clear"', 'Reset').toString() +
				getMonths('long').map((name, index) => h('label', h(`input value="${index + 1}" ${index + 1 === parseInt(month) ? 'checked="checked"' : ''} type="radio" name="month"`)('span', name))).join('')
			)
				('div class="cover"')
		).Node,
		section = container.querySelector('section'),
		selectYear = container.querySelector('select'),
		clear = container.querySelector('button.clear');

	domWrap(container).on('change', 'input[type="radio"]', function () {
		year = selectYear.value;
		month = this.value.padStart(2, '0');
		updateInput();
	});

	selectYear.addEventListener('change', () => {
		year = selectYear.value;
		updateInput();
	});
	input.parentNode.insertBefore(container, input);
	container.insertBefore(input, section);

	container.querySelector('.cover').addEventListener('click', () => container.classList.remove('active'));
	input.addEventListener('click', () => container.classList.add('active'));
	clear.addEventListener('click', resetInput);

	function updateInput() {
		input.value = [year, month].join(separator);
		if (year && month) {
			container.classList.remove('active');
			input.dispatchEvent(new Event('change'));
		}
	}

	function resetInput() {
		year = month = "";
		input.value = "";
		container.classList.remove('active');
		selectYear.selectedIndex = 0;
		[...container.querySelectorAll('input[type="radio"]')].forEach(input => input.checked = false);
		input.dispatchEvent(new Event('change'));
	}

	return container;
}

export default monthPicker;